import { Component, Input, OnInit } from '@angular/core';
import { BaseComponent } from '../../../../shared/utils/base.component';
import { SectionsService } from '../../../../services/sections.service';
import { NzGridModule } from 'ng-zorro-antd/grid';
import { CommonModule } from '@angular/common';
import { UserService } from '../../../../services/user.service';

@Component({
  selector: 'ppl-auth-additional-details',
  standalone: true,
  imports: [NzGridModule,
    CommonModule
  ],
  templateUrl: './auth-additional-details.component.html',
  styleUrl: './auth-additional-details.component.css'
})
export class AuthAdditionalDetailsComponent extends BaseComponent implements OnInit{
  program: any;
  @Input() authData: any;
  /** Flow of the hosting authorization details; falls back to the shared flow when not passed. */
  @Input() contextFlow?: string;

  constructor(private sectionsService: SectionsService, private userService: UserService){
      super();
  }

  ngOnInit(): void {
    this.program = this.userService.getSelectedProgram();
    const secData = this.sectionsService.getSectionData(
      this.program.program_code,
      'payroll',
      undefined,
      this.contextFlow || undefined
    );
    this.secData = secData.additionalDetails;
  }

}
